import { render, staticRenderFns } from "./scan.vue?vue&type=template&id=3b973dfe&scoped=true"
import script from "./scan.vue?vue&type=script&lang=js"
export * from "./scan.vue?vue&type=script&lang=js"
import style0 from "./scan.vue?vue&type=style&index=0&id=3b973dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b973dfe",
  null
  
)

export default component.exports